export class TfConstraintData {
    constructor() {
        this.boneIndexs = [];
    }
}
